var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-auth-container"},[_c('h1',{staticClass:"no-auth-title"},[_c('Icon',{attrs:{"type":"md-close","color":"#ff6b6b"}}),_vm._v(_vm._s(_vm.getTranslation("c019"))+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }